import styled from "styled-components";

export const Title = styled.div`
  font-weight: 700;
  font-size: 38px;
  text-align: center;
`;
